import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateMenu } from "../../redux/commonSlice";
import '../../assets/styles/menu.scss';

const SidebarMenu = ({ menuItems, isExpanded, onCloseSidebar }) => {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(null);
  const [expandedItems, setExpandedItems] = useState({});
  const [activeParentItems, setActiveParentItems] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    const findActiveItem = (items, parentKey = "") => {
      if (location.pathname === "/profile") {
        setActiveItem("5");
        dispatch(updateMenu({ label: "User Profile", icon: "" }));
        return;
      }

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const uniqueKey = parentKey ? `${parentKey}-${i}` : `${i}`;

        if (item.url && item.url === location.pathname) {
          !parentKey && dispatch(updateMenu(item));
          setActiveItem(uniqueKey);
          if (parentKey) {
            setActiveParentItems((prev) => ({
              ...prev,
              [parentKey]: true,
            }));
          }
          return uniqueKey;
        }

        if (item.items) {
          const nestedActiveKey = findActiveItem(item.items, uniqueKey);
          if (nestedActiveKey) {
            setExpandedItems((prevExpandedItems) => ({
              ...prevExpandedItems,
              [uniqueKey]: true,
            }));
            setActiveParentItems((prev) => ({
              ...prev,
              [uniqueKey]: true,
            }));
            !parentKey && dispatch(updateMenu(item));
            return nestedActiveKey;
          }
        }
      }
      return null;
    };

    findActiveItem(menuItems);
  }, [location.pathname]);

  const handleItemClick = (uniqueKey, command) => {
    setActiveItem(uniqueKey);
    setActiveParentItems({});
    if (command) command();
  };

  const stopClickPropagation = (e) => {
    // e.stopPropagation(); // prevents the parent click from firing
  };

  const toggleExpand = (uniqueKey) => {
    if (!isExpanded) return; // Don't allow expanding when sidebar is collapsed
    setExpandedItems((prevExpandedItems) => ({
      ...prevExpandedItems,
      [uniqueKey]: !prevExpandedItems[uniqueKey],
    }));
  };

  const renderMenuItems = (items, parentKey = "") => {
    return items.map((item, index) => {
      const uniqueKey = parentKey ? `${parentKey}-${index}` : `${index}`;
      const isExpandedItem = expandedItems[uniqueKey];
      const hasChildren = item.items && item.items.length > 0;
      const isActive = activeItem === uniqueKey || activeParentItems[uniqueKey];

      return (
        <div key={uniqueKey}>
          <div
            onClick={
              hasChildren || isExpandedItem
                ? stopClickPropagation
                : onCloseSidebar
            }
          >
            <div
              className={`menu-item ${isActive ? "active" : ""} ${
                uniqueKey.length > 1 ? "child" : ""
              }`}
              onClick={() => {
                if (hasChildren && isExpanded) {
                  toggleExpand(uniqueKey);
                } else {
                  handleItemClick(uniqueKey, item.command);
                }
              }}
            >
              <div
                className="flex gap-2 align-items-center"
                style={{
                  justifyContent: isExpanded ? "flex-start" : "center",
                  width: "100%",
                }}
              >
                <div
                  className="icon text-center flex"
                  style={{
                    margin: isExpanded ? "0 0" : "0 auto",
                    fontSize: item.icon === "icon-circle" ? "12px" : "22px",
                  }}
                >
                  {typeof item.icon === "string" ? (
                    <i className={item.icon } style={{ fontWeight: item.icon === "icon-circle" ? "700" : "normal" }}></i>
                  ) : (
                    item.icon
                  )}

                  {!isExpanded && item.iconShow && (
                    <div>
                      {isExpandedItem ? (
                        <i className="icon-chevron-down absolute" style={{ fontSize: "22px" }}></i>
                      ) : (
                        <i className="icon-chevron-right absolute" style={{ fontSize: "22px" }}></i>
                      )}
                    </div>
                  )}
                </div>

                <div >
                  <span style={{ display: isExpanded ? "block" : "none",  marginTop: "2px" }}>
                    {item.label}
                  </span>
                </div>
              </div>

              {isExpanded && item.iconShow && (
                <div>
                  {isExpandedItem ? (
                    <i className="icon-chevron-down" style={{ fontSize: "22px" }}></i>
                  ) : (
                    <i className="icon-chevron-right" style={{ fontSize: "22px" }}></i>
                  )}
                </div>
              )}
            </div>
          </div>

          {hasChildren && isExpandedItem && isExpanded && (
            <div className="submenu">
              {renderMenuItems(item.items, uniqueKey)}
            </div>
          )}
        </div>
      );
    });
  };

  return <div className="sidebar flex flex-column gap-2">{renderMenuItems(menuItems)}</div>;
};

export default SidebarMenu;
